import { render, staticRenderFns } from "./LuJhu.vue?vue&type=template&id=6f5a4c15&"
import script from "./LuJhu.vue?vue&type=script&lang=js&"
export * from "./LuJhu.vue?vue&type=script&lang=js&"
import style0 from "./LuJhu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports